<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="功能标识"
                  :rules="rules.identifier"
                  v-model="item.identifier"
                />
              </v-flex>


              <v-flex xs10>
                <v-text-field
                  label="功能名称"
                  :rules="rules.required"
                  v-model="item.name"
                />
              </v-flex>

              <v-flex xs2>
                <v-select
                  label="禁用"
                  v-model="item.disabled"
                  :items="[{value: true, text:'是'},{value: false, text:'否'}]"
                  :rules="rules.binary"
                />
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                  label="需要的API"
                  item-text="url"
                  item-value="dbid"
                  autocomplete
                  clearable
                  multiple
                  :loading="restApiLoading"
                  :items="restApiItems"
                  :search-input.sync="restApiSearch"
                  v-model="item.restApiIds"
                  v-on:keyup.enter="onApiSearch"
                  @click:append="onApiSearch"
                  hint="输入关键词检索"
                  persistent-hint
                  required
                  :rules="rules.required"
                >
                  <template slot="selection" slot-scope="data">
                    <v-chip
                      close
                      small
                      :selected="data.selected"
                      class="chip--select-multi"
                      :key="data.item.dbid"
                      @input="onRestApiSelectClose(data.item.dbid)"
                    >
                      {{data.item.method}} {{ data.item.url }}
                    </v-chip>
                  </template>
                  <template slot="item" slot-scope="data">
                    <v-list-tile-action style="width: 6em">
                      {{data.item.method}}
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="data.item.url"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>

              <v-flex xs12>
                <v-text-field label="备注" v-model="item.note"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/syst/function';
  const apiUri = '/api/syst/rest-api';

  export default {
    mixins: [mixin.edit(baseUri)],
    data() {
      return {
        formValid: false,

        item: {},
        freshItem: {
          "identifier": null,
          "name": null,
          "disabled": null,
          "note": null,

          "restApiIds": []
        },


        /**
         * 验证规则
         */
        rules: {
          identifier: [
            v => !!v || '必填项。',
            v => (v && v.length <= 50) || '长度必须小于50个字符。',
            v => (v && /^[a-z0-9_]+$/ig.test(v)) || '只能是小写字母、数字和下划线'

          ],

          binary: [
            v => (v === true || v === false) || '必填项。'
          ],

          required: [
            v => !!v || '必填项。',
            v => (v && v.length <= 50) || '长度必须小于50个字符。'
          ]
        },

        restApiLoading: false,
        restApiItems: [],
        restApiSearch: ''
      }
    },
    methods: {
      // mixin 加载数据后调用
      afterGetData(data) {
        window.console.log("afterGetData");

        this.restApiItems = data.restApis || [];
        data.restApiIds = this.restApiItems.map(a => a.dbid);
      },

      // 功能下拉框
      onApiSearch() {
        const vm = this;
        const param = window.xutil.param("url", this.restApiSearch);
        param["sort"] = "url.asc";

        vm.restApiLoading = true;
        this.axios.get(apiUri, {params: param})
          .then(
            rsp => {
              vm.restApiLoading = false;
              vm.restApiItems = rsp.data.items
            })
      },

      // 关闭已选中 REST API 的响应函数
      onRestApiSelectClose(key) {
        const idx = this.item.restApiIds.findIndex(k => k === key);
        if (idx >= 0) {
          this.item.restApiIds.splice(idx, 1);
        }
      },
    }
  }
</script>
